// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39JLv","textarea":"styles_textarea__CID6J"};